export default "/images/lokal.avif?6dd618be953bc856267bf2ddb77d0756";